import { useI18n } from "@/i18n";
import { SectionShell } from "@/components/section-shell";

// Sipariş grubu: Masalar · Mutfak · Personel
// Sidebar tarafında `venue.orderEnabled !== false` ise gösteriliyor;
// QR-only restoranlar bu sekmeyi hiç görmüyor (yine de direkt URL ile
// gelinirse sayfalar açılır — sadece sidebar görünürlüğü gizliyor).
export function OrdersSection() {
  const { t } = useI18n();
  return (
    <SectionShell
      tabs={[
        { to: ".", label: t("tables"), end: true },
        { to: "kitchen", label: t("kitchen") },
        { to: "staff", label: t("staff") },
      ]}
    />
  );
}
